export function ValidateGlobalGoalsRequired(control) {
  if (control.value.some((c) => c !== null && c !== '[]')) {
    return;
  }
  return { validGlobalGoals: true };
}
